
    const data = {"name":"hamburger","data":{"width":"19","height":"14","viewBox":"0 0 19 14","data":"<path pid=\"0\" d=\"M1.105 1h16m-16 6h16m-16 6h16\" _stroke=\"#000\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>","originalColors":[{"type":"stroke","color":"#000"}],"stopColors":[]}}

            export default data
            